import moment from 'moment';
import { formatNumber } from 'utils/number';
import { Button } from 'antd';

import { BondProduct } from 'global/Securities/types/api/bond';

import { useBondsModalStore } from '../../../stores/useBondsModalStore';
import { Field, FieldSet } from '../../../styled';

import BondProductDisplay from '../../BondProductDisplay';

import { ProductCard, ProductCardBody, ProductCardHeader } from '../styled';
import useBondsAnalytics from '../../../useBondsAnalytics';

interface Props {
  investmentModal: number;
  orderDate: Date;
  orderId: string;
  product: BondProduct;
  totalUnits: number;
  isStableEarn?: boolean;
}

export default function ProductListItem({
  investmentModal,
  orderDate,
  orderId,
  product,
  totalUnits,
  isStableEarn = false,
}: Props) {
  const { FRBondActionTrackers } = useBondsAnalytics();
  const openSellModal = useBondsModalStore((s) => s.openSellModal);

  const onChooseClick = () => {
    FRBondActionTrackers.onOrderButtonClicked('Sell', product.id);
    openSellModal(product.id, orderId);
  };

  return (
    <ProductCard>
      <ProductCardHeader>
        <BondProductDisplay
          product={product}
          isStableEarn={isStableEarn}
          cta={
            <Button
              type="primary"
              onClick={onChooseClick}
              css={`
                width: 100px;
                height: 30px;
              `}
            >
              Pilih
            </Button>
          }
        />
      </ProductCardHeader>
      <ProductCardBody>
        <FieldSet>
          <Field>
            <span>Modal Investasi</span>
            <b>
              Rp
              {formatNumber(investmentModal, true, '0,0.00')}
            </b>
          </Field>
          <Field>
            <span>Jumlah Unit</span>
            <b>{totalUnits} Unit</b>
          </Field>
          <Field>
            <span>Tanggal Pembelian</span>
            <span>{moment(orderDate).format('DD MMM YY, HH:mm')}</span>
          </Field>
        </FieldSet>
      </ProductCardBody>
    </ProductCard>
  );
}
